// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2K_Vb","clinicsSelect":"styles_clinicsSelect__7grtx"};